<template src="@/templates/account/passwordChange.html"></template>

<script>
import LoginModel from "@/models/loginModel";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";

export default {
  name: "PasswordChange",
  props: ["popupActive"],
  mixins: [validationMixin],
  validations: {
    changePassword: {
      email: {
        required,
        email,
      },
    },
  },
  data() {
    return {
      changePassword: {
        email: "",
      },
    };
  },
  methods: {
    sendPasswordLink() {
      this.loginModel = new LoginModel();
      this.loginModel
        .save({
          url:
            this.$interpretersApiUrl +
            this.loginModel.getRoute("changePassword"),
          data: {
            email: this.changePassword.email,
          },
        })
        .then((res) => {
          console.log(res);
          let response = res.response.data;

          if (!response) {
            let errorMessage = "Network error. " + response.message;
            this.passwordResetError(errorMessage);
            return;
          }

          if (response.error) {
            let errorMessage = "User error. " + response.message;
            this.passwordResetError(errorMessage);
          } else {
            this.$vs.notify({
              title: "Success!",
              text: response.message,
              time: 4000,
              color: "success",
              position: "top-center",
            });
          }
          this.changePassword.email = "";
          this.closePopUp();
        });
    },
    passwordResetError(errorMessage) {
      this.$vs.notify({
        title: "Error!",
        text: errorMessage,
        time: 4000,
        color: "danger",
        position: "top-center",
      });
    },
    closePopUp() {
      this.popupActive.show = false;
      this.$emit("closeChangePasswordPopUp");
    },
  },
};
</script>

<style scoped></style>
